'use client'
import { memo } from 'react'
import SimilarPropertiesDemo from './SimilarPropertiesDemo'

export interface Property {
  property_uid: string | number
  title: string
  location?: string
  price?: number
  image_url?: string
  [key: string]: string | number | boolean | undefined
}

export interface SimilarPropertiesResponse {
  data: Property[]
}

interface SimilarPropertiesProps {
  similarPropertyIsLoading: boolean
  similarPropertyData: SimilarPropertiesResponse | null
}

const SimilarProperties = ({
  similarPropertyIsLoading,
  similarPropertyData,
}: SimilarPropertiesProps) => {
  const data = similarPropertyData?.data ?? []

  return (
    <div className='p-5 md:p-0 relative z-10 md:mb-4 mb-10'>
      <SimilarPropertiesDemo
        data={data}
        similarPropertyIsLoading={similarPropertyIsLoading}
      />
    </div>
  )
}

export default memo(SimilarProperties)
